import React from 'react'
import ReactDOM from 'react-dom'
import './index.css'
import App from './App'

// TODO Get rid of hack and wait while textures are processed
setTimeout(() => ReactDOM.render(<App />, document.getElementById('root')), 0)

